import React, { useState } from "react";
import { connect } from "react-redux";
import { Draggable } from "react-beautiful-dnd";
import ColumnHeader from "./ColumnHeader";
import EGCards from "./Cards";
import CrewForm from '../Crew/CrewForm';
import { isToday, usePermission } from "../../../helpers/common";

const getItemStyle = (draggableStyle) => ({
    userSelect: 'none',
    ...draggableStyle,
});

const Column = props => {
    const { columnId, crewId, index, isRequestingCrew, isHaveCrew, search } = props;
    const [openModal, setOpenModal] = useState(false);
    const allow = usePermission();
    const isAllowCreate = allow("crew", "create") ? !isRequestingCrew && isToday(search.range) : false;

    return <>
        <Draggable key={columnId} draggableId={columnId} index={index} isDragDisabled={!isHaveCrew}>
            {(provided) => (
                <div className={`kanban-column-wrap col col${index + 1}`}
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    style={getItemStyle(provided.draggableProps.style)}
                >
                    <div className="kanban-column-bg">
                        {isHaveCrew ? <div className="kanban-column">
                            <ColumnHeader crewId={crewId} />
                            <EGCards crewId={crewId} />
                        </div>
                            : isAllowCreate && <div className="kanban-column-add">
                                <span onClick={() => setOpenModal(!openModal)}><i className="fa fa-plus-circle" />Add crew</span>
                            </div>}
                    </div>
                </div>
            )}
        </Draggable>
        {openModal && <CrewForm show={openModal} onHide={() => setOpenModal(!openModal)} />}
    </>;
};


const mapStateToProps = (state, ownProps) => ({
    isHaveCrew: state.crewKanban.crews.hasOwnProperty(ownProps.crewId),
    isRequestingCrew: state.crewKanban.isRequestingCrew,
    search: { range: state.analyze.searchParams.range }
});

export default connect(mapStateToProps)(Column);